/**
 * AxLabs Simulation Core - Type Definitions
 *
 * Core types for the deterministic simulation engine.
 * All simulations must use SI units and be dimensionally consistent.
 */
/**
 * Common SI unit dimensions
 */
export const DIMENSIONS = {
    DIMENSIONLESS: { L: 0, M: 0, T: 0, I: 0, Θ: 0, N: 0, J: 0 },
    LENGTH: { L: 1, M: 0, T: 0, I: 0, Θ: 0, N: 0, J: 0 },
    MASS: { L: 0, M: 1, T: 0, I: 0, Θ: 0, N: 0, J: 0 },
    TIME: { L: 0, M: 0, T: 1, I: 0, Θ: 0, N: 0, J: 0 },
    VELOCITY: { L: 1, M: 0, T: -1, I: 0, Θ: 0, N: 0, J: 0 },
    ACCELERATION: { L: 1, M: 0, T: -2, I: 0, Θ: 0, N: 0, J: 0 },
    FORCE: { L: 1, M: 1, T: -2, I: 0, Θ: 0, N: 0, J: 0 },
    ENERGY: { L: 2, M: 1, T: -2, I: 0, Θ: 0, N: 0, J: 0 },
    POWER: { L: 2, M: 1, T: -3, I: 0, Θ: 0, N: 0, J: 0 },
    PRESSURE: { L: -1, M: 1, T: -2, I: 0, Θ: 0, N: 0, J: 0 },
    FREQUENCY: { L: 0, M: 0, T: -1, I: 0, Θ: 0, N: 0, J: 0 },
    ELECTRIC_POTENTIAL: { L: 2, M: 1, T: -3, I: -1, Θ: 0, N: 0, J: 0 },
    ELECTRIC_RESISTANCE: { L: 2, M: 1, T: -3, I: -2, Θ: 0, N: 0, J: 0 },
    CAPACITANCE: { L: -2, M: -1, T: 4, I: 2, Θ: 0, N: 0, J: 0 },
    TEMPERATURE: { L: 0, M: 0, T: 0, I: 0, Θ: 1, N: 0, J: 0 },
    CONCENTRATION: { L: -3, M: 0, T: 0, I: 0, Θ: 0, N: 1, J: 0 },
    ANGLE: { L: 0, M: 0, T: 0, I: 0, Θ: 0, N: 0, J: 0 }, // radians are dimensionless
};
//# sourceMappingURL=types.js.map